var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group read-only",class:_vm.clazz},[_c('label',{class:_vm.titleClazz},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.currency)?_c('p',{class:_vm.textClazz},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.text))+" ")]):_c('p',{class:_vm.textClazz},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }